const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { multiTenant: true }, { assetClass: { $ne: 'object.asset-class.options.freies-ankaufsprofil' } }]
}

export default conditions
